
/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

 /*
 *
 * Model structure
 * ---------------
 *
 * The models in use are *NO* submodels and have no links
 * to their parents.
 *
 *              SearchModel
 *               /       \
 *              /         \
 *           * /           \ *
 *  ResultCollection  FacetValueCollection (added by: addResultCollection & addFacet)
 *            |            |
 *            |            |
 *          * |            | *
 *    ComputedModel     ComputedModel
 *
 *
 * Questions
 * ---------
 *
 * How can I trigger actions on parent models?
 *  + delegate in the views? (lookup NSTableView)
 *  + link models
 */

 Mindbreeze.define('api/v2/search',["i18n/i18n", "api/v2/common", "backbone", "underscore", "model/readonlytree", "model/tree", "model/computed", "model/compute_wiring", "model/properties", "service/stub", "service/factory", "utils/jsonpath", "utils/clone", "utils/encode", "utils/string", "utils/browser", "model/attribute_proxy",
  "service/channel"],
   function(i18n, Common, Backbone, _, ReadOnlyTreeModel, TreeModel, ComputedModel, ComputeWiring, PropertiesModel, Stub, ServiceFactory, JSONPath, clone, Encode, StringUtil, browser, AttributeProxyModel,
    Channel
  ){

   var USER_GENERATED_REGEXP = /user_generated_\d+/;

   var DEFAULT_RESULT_RANK_SCORE_COMPARATOR = function (lhsResult, rhsResult) {
     var lhsRank = lhsResult ? lhsResult.rank_score : -1;
     var rhsRank = rhsResult ? rhsResult.rank_score : -1;

     if (lhsRank >= rhsRank) {
       return -1;
     }
     return 1;
   };

   var DEFAULT_RESULT_COMPARATOR = function(lhsResult, rhsResult) {
     var lhsValue = lhsResult ? lhsResult.order : null;
     var rhsValue = rhsResult ? rhsResult.order : null;
     // if either of the result elements has no order, revert to the rank_score
     if (lhsValue == null || rhsValue == null) {
       return DEFAULT_RESULT_RANK_SCORE_COMPARATOR(lhsResult, rhsResult);
     }
     return - Common.valueCompare(lhsValue, rhsValue);
   }

   var prepareOrder = function(results) {

     if (results) {
       var maxValue = _.max(results, function(result){
         if (result.order) return result.order;
       }).order;

       for (var i = 0; i < results.length; i++) {
           var orderObj = results[i].order;
           if (_.isNumber(orderObj)) {
             if(_.isNumber(maxValue)) {
               var value = Math.round( ((orderObj/maxValue) * 100) * 100) / 100;
             } else {
               var value = 0;
             }
             value = value + "";

             results[i].properties["relevance_order"] = {
               data: [{ "value": value }],
               id: "relevance_order",
               name: "relevance_order"
             }
           }
       }
     }

     return results;
   }

   function _updateProperties(originalProperties) {
     var nestedProperties = this.options.nestedProperties;

     function mergeProperty(lhs, rhs, propertyName) {
       if (!lhs) {
         lhs = {formats:[]};
       }
       if (!rhs) return lhs;


       var formats = rhs.formats || [rhs.format];
       lhs.formats = _.union(lhs.formats, formats);

       if (!lhs.properties && rhs.properties) {
         lhs.properties = {}; // rhs.properties;
       }
       if (lhs.properties && rhs.properties) {
         _.each(_.union(_.keys(lhs.properties), _.keys(rhs.properties)), function (key) {
             if (!_.contains(nestedProperties, key)) {
               if (lhs.properties[key]) delete lhs.properties[key].properties;
               if (rhs.properties[key]) delete rhs.properties[key].properties;
             }
             lhs.properties[key] = mergeProperty(lhs.properties[key], rhs.properties[key], key);
         });
       }
       return lhs;
     }

     originalProperties = _.clone(originalProperties);
     if (!originalProperties.noadditionalproperties) {
       originalProperties["mes:key"] = originalProperties["mes:key"] || { format: "VALUE" };
       originalProperties["category"] = originalProperties["category"] || { format: "VALUE" };
       originalProperties["categoryinstance"] = originalProperties["categoryinstance"] || { format: "VALUE" };
     }
     delete originalProperties.noadditionalproperties;
     var props = {};
     var properties = {};
     _.each(_.keys(originalProperties), function(propName) {

         var propPath = JSONPath.parsePath(propName);

         if (!_.isArray(propPath) || propPath.length == 0) {
           // TODO change error handling here
           return;
         }

         var propRoot = propPath[0];

         var property = _.clone(originalProperties[propName]);

         if (!_.contains(nestedProperties, propRoot)) {
           delete property.properties;
         }

         property.root = propRoot;
         property.path = propPath.slice(1);

         props[propRoot] = mergeProperty(props[propRoot], property, propRoot);

         /*
         var formats = property.formats || [property.format];
         if (props[propRoot]) {
           props[propRoot].formats = _.union(props[propRoot].formats, formats);
         }
         else {
           props[propRoot] = { formats: formats };
         }
         */
         properties[propName] = property;

     });

     this.originalProperties = properties;
     this.properties = props;
     return this;
   }

   var Search = {};

   Search.DISPLAY_TIMEOUT = 3000;

   Search.PropertyFormat = Common.PropertyFormat;

   Search.createStringFacetValue =  function(label, entry) {
     if (_.isString(entry)) {
       entry = {value: entry};
     }

     if (!entry.html) {
       entry.html = Encode.htmlEncode(entry.value);
     }

     entry.query_expr = entry.query_expr || {
       "label": label,
       "description": entry.html,
       "regex": "^\\Q" + entry.value + "\\E$",
       "path": []
     };
     entry.query_expr.id = entry.query_expr.id || entry.value;

     var result = {
       "html": entry.html,
       "query_expr": entry.query_expr
     };
     if (entry.count != null) {
       result.count = entry.count;
     }
     return result;
   }


   Search.createStringFacetValues =  function(id, values) {
     return _.map(values, _.bind(Search.createStringFacetValue, Search, id));
   }

   Search.createStringFacet =  function(facet, values) {

     facet.entries = _.map(values, _.bind(Search.createStringFacetValue, Search, facet.id));
     return facet;
   }

    Search.addFacetValue = function (searchModel, id, entry, options) {
      options = _.extend({ merge: true }, options);
      var path = "facets['" + id + "']";
      var model = searchModel.output;
      var facet;

      facet = model.submodel(path + ".entries");
      facet.load([Search.createStringFacetValue(id, {
        value: entry,
        query_expr: {
            label: id,
            description: entry,
            regex: "^\\Q" + entry + "\\E$",
            path: []          
        }
      })], options);
    }

    /**
    * @namespace common
    */
   /**
    * @typedef PropertyName
    * @memberof common
    * @type {Object}
    * @property {string} name
    * @property {string} localized_name
    */

    /**
    * @typedef AggregatedProperty
    * @memberof common
    * @type {Object}
    * @property {string} id
    * @property {string} name
    * @property {string} order_criteria
    * @property {string} order_direction
    * @property {common.Entry[]} entries
    */

    /**
    * @typedef Entry
    * @memberof common
    * @type {Object}
    * @property {string} html
    * @property {number} count
    * @property {string} order_criteria
    * @property {string} order_direction
    * @property {boolean} excluded
    * @property {common.QueryExpr[]} user.query  specifies the user query
    */

    /*
     Examples for query expr
     { label: "foo", and: [ { term: "X" }, { term: "Y"}] }
     { not: { include: {term: "x" }, exclude: [ {unparsed: ".."} ] } }
     { start: {term : "7"}, to: {term: "8"} }
     { unparsed: "X", not: [{unparsed: "Y"}]}}
     { cmp: "LE", num_int: 1221, unit: "ms_since_1970"}
    */

    /**
    * @typedef  QueryExpr
    * @memberof common
    * @type  {Object}
    * @property {number} boost       expr boost
    * @property {bool}   expandable  Should query expansion be performed on this
    * @example <caption>QueryExpr examples</caption>

     { unparsed: "Example query title:\"Mindbreeze\"" }     // parsed at query service (according to query syntax)
     { label: "foo", and: [ { term: "X" }, { term: "Y"}] }  // query within property 'foo' for 'X' and 'Y"
     { start: {term : "7"}, to: {term: "8"} }               // query for range (7,8)
     { unparsed: "X", not: [{unparsed: "Y"}]}}              // mixed unparsed in NOT
     { cmp: "LE", num_int: 1420066800000, unit: "ms_since_1970"}   // < queries for 2015-01-01 (GMT)
    */

    /**
    * @typedef SearchResponse
    * @memberof search
    * @type  {Object}
    * @property {number} estimated_count
    * @property {string} name
    * @property {string} orderby
    * @property {common.PropertyName[]} available_facets
    * @property {common.PropertyName[]} available_properties
    * @property {common.PropertyName[]} orderable
    * @property {common.PropertyName[]} groupable
    * @property {common.AggregatedProperty[]} facets
    * @property {search.ResultSet} resultset
    */

    /**
    * @typedef ResultSet
    * @memberof search
    * @type  {Object}
    * @property {bool} prev_avail
    * @property {bool} next_avail
    * @property {string} order_direction
    * @property {search.Result[]} results
    */

   /**
    * @typedef Result
    * @memberof search
    * @type  {Object}
    * @property {string} id
    * @property {string} location
    * @property {number} rank_score
    * @property {number} relevance_score
    */




   var SearchResponse = {

     parseResult: function (result, options) {
         result.id = (options.channel && options.channel.id ? options.channel.id + "." : "") + options.view_id + "." + result.location;
         result.channel = options.channel;
         // if (result.order == null) {
         //   // backwards-compat 10000
         //   result.order = { num: result.rank_score * 10000 };
         // }
         if (result.order != null)
           result.order = Common.Properties.parseValue(result.order);
         result.properties = Common.Properties.parse({}, result.properties);
         return result;
     },

     parseResults: function (results, options) {
         return _.map(results, function (result) {
           return SearchResponse.parseResult(result, options);
         });
     },

     parsePerServiceDataset: function (per_service_dataset) {
       if (per_service_dataset.paging_state) {
         per_service_dataset.paging_state.service_id = per_service_dataset.id;
       }
       return per_service_dataset;
     },

     parseAlternatives: function(alternatives, options) {
       var facets = {};
       _.each(alternatives, function(facet) {
         if (!facets[facet.id]) {
           facets[facet.id] = facet;
         }
         else if (_.isArray(facets[facet.id])) {
           facets[facet.id].push(facet);
         }
         else {
           facets[facet.id] = [facets[facet.id], facet]
         }
       });
       return facets;
     },

      parseFacetEntries: function(entries, options) {
        var options = options || {};
        return SearchResponse.filterEmptyFacetEntries(_.map(entries, function (entry) {
          entry.isUserGenerated =  entry && entry.query_expr && USER_GENERATED_REGEXP.test(entry.query_expr.id);
          entry.properties = Common.Properties.parse({}, entry.properties);

          if (entry.value) entry.value = Common.Properties.parseValue(entry.value);
          if (entry.query_expr) entry.query_expr.path = options.path;
          if (entry.entries) {
            var path = (options.path || []).concat(entry.query_expr);
            entry.entries = SearchResponse.parseFacetEntries(entry.entries, _.extend({}, options, { path: path }));
          }

          entry.showAddAnd = (!options.path || options.path.length < 1) && (entry.isUserGenerated || entry.count) && (!entry.entries || entry.entries.length < 1);

          return entry;
        }));
      },

      filterEmptyFacetEntries: function (entries) {
        return _.filter(entries, function (entry) {
          return entry.html && StringUtil.trim(entry.html) || entry.properties != null;
        });
      },

      parseFacet: function(facet, options) {
        facet.entries = SearchResponse.parseFacetEntries(facet.entries, options);
        return facet;
      },

      parseFacets: function(responseFacets, options) {
       var facets = {};
       _.each(responseFacets, function(facet) {
         facet = SearchResponse.parseFacet(facet, options);

         if (!facets[facet.id]) {
           facets[facet.id] = facet;
         }
         else if (_.isArray(facets[facet.id])) {
           facets[facet.id].push(facet);
         }
         else {
           facets[facet.id] = [facets[facet.id], facet]
         }
       });
       return facets;
     },


     parseResultSet: function (resultset, status_messages, options) {
       resultset = _.clone(resultset);
       // if (resultset.order_direction == null) {
       //   // TODO Change this.
       //   resultset.order_direction = "DESCENDING";
       // }
       resultset.results = SearchResponse.parseResults(resultset.results, options);
       resultset.per_service_dataset = _.collect(resultset.per_service_dataset, SearchResponse.parsePerServiceDataset)
       if (resultset.order_next_result != null) resultset.order_next_result = Common.Properties.parseValue(resultset.order_next_result);

       var enableRelevanceInfo = browser.getURLParameter("relevance-info") === "true";
       if (enableRelevanceInfo) {
         resultset.results = prepareOrder(resultset.results);
       }

       resultset.result_pages = SearchResponse.parseResultPages(resultset.result_pages, status_messages, options);

       return resultset;
     },

     // adds synthesized properties:
     //
     // onFirstPage: true, if current_page is the first page
     // onLastPage: true, if current_page is the last page
     // original_page_numbers: an array of the original page_number properties for each qeng
     // order_range: [<order>, <order of next page> OR null for last page]
     //
     // pages[0].current_page is set to true, if no other page has current_page set
     parseResultPages: function (pages, status_messages, options) {
       var pagingFailed = !!(status_messages && status_messages.paging_failed);
       var currentPageFound = false;
       var i;

       if (pages && pages.pages && pages.pages.length) {
         _.each(pages.pages, function (page, index) {
             currentPageFound = currentPageFound || page.current_page;
             page.page = page.page_number + 1;
             page.original_page_numbers = [];
             for (i=0; i<page.starts.length; i++) {
               page.original_page_numbers.push(page.page_number);
             }
             page.order = Common.Properties.parseValue(page.order);
         });
         for (i=0; i<pages.pages.length - 1; i++) {
           pages.pages[i].order_range = [pages.pages[i].order, pages.pages[i+1].order];
         }
         pages.pages[pages.pages.length - 1].order_range = [pages.pages[pages.pages.length - 1].order, null];
         if (!pagingFailed && !currentPageFound) {
           pages.pages[0].current_page = true;
         }
         pages.onFirstPage = pages.pages[0].current_page === true;
         pages.onLastPage = pages.pages[pages.pages.length-1].current_page === true;
       }

       return pages;
     },

     parse: function(response, options) {
       var result = {};

       options = options || {};

       // we need the status_messages for parsing the resultset, make sure they are set up
       if (response.status_messages) {
         result.status_messages = Common.StatusMessages.parse(response.status_messages);
       }
       for (var name in response) {
         if (!response.hasOwnProperty(name)) {
           continue;
         }
         var responseProperty = response[name];

         // view = _.clone(view);
         // view.results = SearchResponse.parseResults(view.results, options);
         if (name == "resultset") {
           result.resultset = SearchResponse.parseResultSet(responseProperty, result.status_messages, options);
         }
         else if (name == "status_messages") {
           /* already handled above */
         }
         else if (name == "facets") {
           result.facets = SearchResponse.parseFacets(responseProperty, options);
         }
         else if (name == "alternatives") {
           result.alternatives = SearchResponse.parseAlternatives(responseProperty, options);
         }
         else {
           result[name] = response[name];
         }
       }

       if (result && result.resultset) {
         _.each(result.resultset.results, function(result){
           var order = result.order,
               group = result.group && result.group.str;
           if (order) result.properties["order"] = {id: "order", name: "order", data: [{ "value": order }]};
           if (group) result.properties["group"] = {id: "group", name: "group", data: [{ "value": group }]};
         });

         /*
         * enable_rounded_estimated_count is undefined -> true
         * enable_rounded_estimated_count is 'false' -> false
         * enable_rounded_estimated_count is 'true' -> true
         */
         if (result.search_request &&
            (_.isUndefined(result.search_request.enable_rounded_estimated_count) || result.search_request.enable_rounded_estimated_count !== false) && 
            result.resultset.results && result.resultset.results.length < result.estimated_count ) {
          result.is_about = true;
         }
       }

       if (result.estimated_count == 1) result.singular = true;

       return result;
     }
   };

   var SearchOutputModel = Search.SearchOutputModel = ReadOnlyTreeModel.extend({

   createStringFacetValue:  Search.createStringFacetValue,
   createStringFacetValues: Search.createStringFacetValues,
   createStringFacet:       Search.createStringFacet,

   getTypeFromPath: function(path) {
     if (!path) return "SearchResponse";
     //                 : SearchResponse
     // alternatives    : Alternatives
     // facets          : Facets
     // facets.facet    : Facet
     // resultset         : ResultSet
     // resultset.results : Results
     // views.id.facets : Facets
     // views.id.facets.facet : Facet

     // else : undefined
     if (!_.isArray(path)) {
       path = JSONPath.parsePath(path);
     }
     if (path.length == 0) return "SearchResponse";
     if (path[0] == "alternatives") {
       if (path.length == 1) return "Alternatives";
       if (path.length == 2) return "Alternative";
     }
     if (path[0] == "available_properties") {
       if (path.length == 1) return "AvailableProperties";
     }
     if (path[0] == "available_facets") {
       if (path.length == 1) return "AvailableFacets";
     }
     if (path[0] == "orderable") {
       if (path.length == 1) return "Orderables";
     }
     if (path[0] == "resultset") {
       if (path.length == 1) return "ResultSet";
       if (path[1] == "results") {
         if (path.length == 2) return "Results";
         if (path.length == 3) return "Result";
       }
     }

     if (path[0] == "facets") {
       if (path.length == 1) return "Facets";
       if (path.length == 2) return "Facet";
       if (path.length == 3 && path[2] == "entries") return "FacetEntries";
     }
     return undefined;
   },

   getMergeFunctionByType: function(type) {
     if (!type) return undefined;
     switch(type) {
     case "SearchResponse": return _.bind(this.mergeSearchResponse,this);
     case "AvailableFacets": return _.bind(this.mergeAvailableFacets,this);
     case "AvailableProperties": return _.bind(this.mergeAvailableProperties,this);
     case "ResultSet": return _.bind(this.mergeResultSet,this);
     case "ResultPages": return _.bind(this.mergeResultPages,this);
     case "ResultPage": return _.bind(this.mergeResultPage,this);
     case "Results": return _.bind(this.mergeResults,this);
     case "Result": return undefined;
     case "Alternatives": return _.bind(this.mergeAlternatives,this);
     case "Alternative": return _.bind(this.mergeAlternative,this);
     case "Orderables": return _.bind(this.mergeOrderables,this);
     case "Facets": return _.bind(this.mergeFacets,this);
     case "Facet": return _.bind(this.mergeFacet,this);
     case "FacetEntries": return _.bind(this.mergeFacetEntries,this);
     }
     return undefined;
   },

   getParseFunctionByType: function(type) {
     if (!type) return undefined;
     switch(type) {
     case "SearchResponse": return _.bind(this.parseSearchResponse,this);
     case "ResultSet": return _.bind(this.parseResultSet,this);
     case "Pages": return _.bind(this.parseResultPages,this);
     case "Results": return _.bind(this.parseResults,this);
     case "Result": return undefined;
     case "Alternatives": return _.bind(this.parseAlternatives,this);
     case "Alternative": return _.bind(this.parseAlternative,this);
     case "Facets": return _.bind(this.parseFacets,this);
     case "Facet": return _.bind(this.parseFacet,this);
     case "FacetEntries": return _.bind(this.parseFacetEntries,this);

     }
     return undefined;
   },

   mergeResults: function (lhs, rhs, options) {
     options = options || {};

     options.resultComparator = options.resultComparator || options.defaultResultComparator || DEFAULT_RESULT_COMPARATOR;

     if (!lhs) return rhs;
     if (!rhs) return lhs;

     var numberOfResults = lhs.length + rhs.length,
         merged = [],
         lhsIndex = 0,
         rhsIndex = 0,
         lhsResult,
         rhsResult,
         useLhs;

     while (merged.length < numberOfResults) {
       lhsResult = lhsIndex < lhs.length ? lhs[lhsIndex] : null;
       rhsResult = rhsIndex < rhs.length ? rhs[rhsIndex] : null;

       if (!lhsResult) {
         useLhs = false;
       } else if (!rhsResult) {
         useLhs = true;
       } else {
         useLhs = options.resultComparator(lhsResult, rhsResult, options) <= 0;
       }

       if (useLhs) {
         merged.push(lhsResult);
         lhsIndex++;
       } else {
         merged.push(rhsResult);
         rhsIndex++;
       }
     }

     return merged;
   },

   mergeAlternatives: function (lhs, rhs) {
       if (!lhs) return rhs;
       if (!rhs) return lhs;

       var that = this,
           merged = {},
           ids = _.union(_.keys(lhs), _.keys(rhs));
       _.each(ids, function (id) {
             merged[id] = that.mergeAlternative(lhs[id], rhs[id]);
       });
       return merged;
   },


   /*
   * example:
   * [{
   *   "name": "mes:relevance",
   *   "localized_name": "Relevance"
   * }, {
   *   "name": "mes:date",
   *   "localized_name": "Date"
   * }]
   *
   * union by name, using first localized_name
   */
   mergeOrderables: function (lhs, rhs) {
       if (!lhs || lhs.length < 1) return rhs;
       if (!rhs || rhs.length < 1) return lhs;

       var that = this,
           names = _.pluck(lhs, "name"),
           merged = _.reduce(rhs, function (merged, entry) {
             if (_.indexOf(names, entry.name) < 0) {
               names.push(entry);
               merged.push(entry);
             }
             return merged;
           }, [].concat(lhs));

       return merged;
   },

    mergeAvailableFacets: function (lhs, rhs) {
     return Common.mergeByName(lhs, rhs, "name", this.mergeAvailableFacet);
   },

   mergeAvailableProperties: function (lhs, rhs) {
     return Common.mergeByName(lhs, rhs, "name", this.mergeAvailableProperty);
   },

   mergeFacets: function (lhs, rhs) {
       if (!lhs) return rhs;
       if (!rhs) return lhs;

     var that = this,
         merged = {},
         ids = _.union(_.keys(lhs), _.keys(rhs));

     _.each(ids, function (id) {
         merged[id] = that.mergeFacet(lhs[id], rhs[id]);
     });

     return merged;
   },

   mergeAlternativeEntries: function (lhs, rhs) {
     if (!lhs) return rhs;
     if (!rhs) return lhs;
     var merged = _.clone(lhs);

     merged.count += rhs.count;
     if (JSON.stringify(merged.query_expr) != JSON.stringify(rhs.query_expr)) {
       merged.query_expr = { or: [
         merged.query_expr,
         rhs.query_expr
       ]};
     }

     return merged;
   },

   mergeFacetEntry: function (lhs, rhs, options) {

     var options = options || {};
     if (!options.order_mismatch) {
       if (!lhs) return rhs;
       if (!rhs) return lhs;
     }
     if (!lhs && !rhs) return lhs;

     lhs = lhs != null ? lhs : {html: rhs.html, count: 0, query_expr: rhs.query_expr};
     rhs = rhs != null ? rhs : {html: lhs.html, count: 0, query_expr: lhs.query_expr};

     var merged = _.clone(lhs);

     merged.isUserGenerated = merged.isUserGenerated || rhs.isUserGenerated;
     merged.showAddAnd = merged.showAddAnd && rhs.showAddAnd;

     if (!_.isNumber(merged.count)) merged.count = rhs.count;
     else if (_.isNumber(rhs.count)) merged.count += rhs.count;

     if (_.isNumber(merged.count)) {
       delete merged.excluded;
     }

     if (JSON.stringify(merged.query_expr) != JSON.stringify(rhs.query_expr)) {
       merged.query_expr = {
         or: [
           merged.query_expr,
           rhs.query_expr
         ],
         id: merged.query_expr.id || rhs.query_expr.id,
         path: merged.query_expr.path || rhs.query_expr.path
       };
     }

     var orderCriteria = merged.order_criteria;
     var orderDirection = merged.order_direction;
     var orderMismatch = options.order_mismatch || false;

     if (!orderMismatch) {
       if (!rhs.entries) { return merged; }
       if (!merged.entries && rhs.entries) {
         merged.entries = rhs.entries;
         merged.order_criteria = rhs.order_criteria;
         merged.order_direction = rhs.order_direction;
         return merged;
       }
     }

     if (lhs.order_criteria == null || rhs.order_criteria == null || lhs.order_criteria != rhs.order_criteria) {
       orderCriteria = null;
       orderMismatch = true;
     }
     if (lhs.order_direction == null || rhs.order_direction == null || lhs.order_direction != rhs.order_direction) {
       orderDirection = null;
       orderMismatch = true;
     }

     merged.properties = Common.Properties.merge(lhs.properties, rhs.properties);

     merged.entries = this.mergeFacetEntries(merged.entries, rhs.entries,
                                             {order_criteria: orderCriteria,
                                              order_direction: orderDirection,
                                              order_mismatch: orderMismatch});
     return merged;
   },

   mergeAlternative: function(lhs, rhs) {
    var nameIndex = {};
    if (!lhs) lhs = [];
    else if (!_.isArray(lhs)) lhs = [lhs];
    if (!rhs) rhs = [];
    else if (!_.isArray(rhs)) rhs = [rhs];

    // console.log("input",lhs,rhs);
    for (var i = 0; i < lhs.length; ++i) {
        nameIndex[lhs[i].name] = lhs[i];
    }
    for (var i = 0; i < rhs.length; ++i) {
        var name = rhs[i].name;
        if (nameIndex[name]) {
            nameIndex[name] = this.mergeSingleAlternative(nameIndex[name], rhs[i]);
        }
        else {
            nameIndex[name] = rhs[i];
        }
    }
    var keys = _.keys(nameIndex);
    var merged = [];
    for (var i = 0; i < keys.length; i++) {
        merged[i] = nameIndex[keys[i]];
    }
    // console.log("merged", merged);
    if (merged.length == 1) return merged[0];
    return merged;
   },

   mergeFacet: function(lhs, rhs) {
    var nameIndex = {};
    if (!lhs) lhs = [];
    else if (!_.isArray(lhs)) lhs = [lhs];
    if (!rhs) rhs = [];
    else if (!_.isArray(rhs)) rhs = [rhs];
    for (var i = 0; i < lhs.length; ++i) {
        nameIndex[lhs[i].name] = lhs[i];
    }

   for (var i = 0; i < rhs.length; ++i) {
     var name = rhs[i].name;
      if (nameIndex[name]) {
        nameIndex[name] = this.mergeSingleFacet(nameIndex[name], rhs[i]);
      } else {
        nameIndex[name] = rhs[i];
      }
    }
    var keys = _.keys(nameIndex);
    var merged = [];
    for (var i = 0; i < keys.length; i++) {
        merged[i] = nameIndex[keys[i]];
    }
    // console.log("merged", merged);
    if (merged.length == 1) return merged[0];
    return merged;
   },

   mergeSingleAlternative: function (lhs, rhs) {
      if (!lhs) return rhs;
      if (!rhs) return lhs;


     var that = this,
         merged = _.clone(lhs),
         entries,
         lhsByName = Common.mapByPluck(lhs.entries, "html"),
         rhsByName = Common.mapByPluck(rhs.entries, "html"),
         names = _.union(_.keys(lhsByName), _.keys(rhsByName));

     entries = _.map(names, function (name) {
        return that.mergeAlternativeEntries(lhsByName[name], rhsByName[name]);
     });

     merged.entries = entries.sort(function (lhs, rhs) {
       return rhs.count - lhs.count;
     });

     return merged;

   },

   mergeSingleFacet: function (lhs, rhs, options) {
       if (!lhs) return rhs;
       if (!rhs) return lhs;

     var merged = _.clone(lhs);

     var orderCriteria = merged.order_criteria;
     var orderDirection = merged.order_direction;

     var orderMismatch = false;
     if (lhs.order_criteria == null || rhs.order_criteria == null || lhs.order_criteria != rhs.order_criteria) {
       orderCriteria = null;
       orderMismatch = true;
     }
     if (lhs.order_direction == null || rhs.order_direction == null || lhs.order_direction != rhs.order_direction) {
       orderDirection = null;
       orderMismatch = true;
     }
     merged.count_filtered_facet_values = merged.count_filtered_facet_values && rhs.count_filtered_facet_values;

     merged.entries = this.mergeFacetEntries(merged.entries, rhs.entries,
                                             {order_criteria: orderCriteria,
                                              order_direction: orderDirection,
                                              order_mismatch: orderMismatch});

     merged.configured = lhs.configured || rhs.configured;

     return merged;
   },

   getFacetCompareFunction: function(orderCrit, orderDir)  {
     // sort DESCENDING by default
     if (orderDir !== 'ASCENDING') {
       orderDir = 'DESCENDING';
     }
     return _.bind(Common.getCompareFunction(orderCrit, orderDir), this);
   },

   mergeFacetEntries: function (lhs, rhs, options) {
     var options = options || {};
     var orderMismatch = options.order_mismatch;

     if (!orderMismatch) {
       if (!lhs) return rhs;
       if (!rhs) return lhs;
     }

     lhs = lhs || [];
     rhs = rhs || [];

     var parentOrderCrit, parentOrderDir;
     if (options.parent) {
       parentOrderCrit = options.parent.order_criteria;
       parentOrderDir = options.parent.order_direction;
     }

     var orderCrit = options.order_criteria || parentOrderCrit || "COUNT";
     var orderDir  = options.order_direction || parentOrderDir ||  "DESCENDING";

     var entries = [];
     entries = entries.concat(_.filter(lhs, function(entry) { return entry.html == null && entry.properties; }));
     entries = entries.concat(_.filter(rhs, function(entry) { return entry.html == null && entry.properties; }));
     
     var that = this,
         entries,
         lhsByName = Common.mapByPluck(lhs, "html"),
         rhsByName = Common.mapByPluck(rhs, "html"),
         names = _.union(_.keys(lhsByName), _.keys(rhsByName));

     entries = entries.concat(_.map(names, function (name) {
         return that.mergeFacetEntry(lhsByName[name], rhsByName[name], options);
     }));

     entries = entries.sort(this.getFacetCompareFunction(orderCrit, orderDir));

     return entries;
   },

   // merged is new one.
   mergeResultSet: function(lhs, rhs, options, status_messages) {
       if (!lhs) return rhs;
       if (!rhs) return lhs;

       var merged = _.clone(lhs);

       options = options || {};

       var orderDirection = "DESCENDING";
       if (lhs.order_direction == rhs.order_direction &&  lhs.order_direction != null) {
         orderDirection = lhs.order_direction;
       }

       options.orderDirection = orderDirection;
       if (orderDirection == "ASCENDING") {
         // default comparision is DESCENDING.
         options.defaultResultComparator = function(rhs, lhs) { return - DEFAULT_RESULT_COMPARATOR.apply(this, arguments); };
       }

       // merged.id = merged.id || rhs.id;
       merged.results = this.mergeResults(merged.results, rhs.results, options);

       // merge before merging per_service_datasets, so we know we have more results for each object
       merged.order_next_result = this.mergeOrderNextResult(merged.order_next_result, merged.per_service_dataset, rhs.order_next_result, rhs.per_service_dataset, options);

       var enableRelevanceInfo = browser.getURLParameter("relevance-info") === "true";
       if (enableRelevanceInfo) {
         merged.results = prepareOrder(merged.results);
       }

       if (_.isArray(merged.per_service_dataset) && _.isArray(rhs.per_service_dataset)) {

         var result = {};
         for (var i = 0 ; i < merged.per_service_dataset.length; ++i) {
           var dataset = merged.per_service_dataset[i];
           result[dataset.id] = dataset;
         }
         for (var i = 0;  i < rhs.per_service_dataset.length; ++i) {
           var dataset = rhs.per_service_dataset[i];
           result[dataset.id] = dataset;
         }
         merged.per_service_dataset = _.values(result);
       }
       else {
         merged.per_service_dataset = merged.per_service_dataset ? merged.per_service_dataset : rhs.per_service_dataset;
       }
       merged.prev_avail = merged.prev_avail || rhs.prev_avail;
       merged.next_avail = merged.next_avail || rhs.next_avail;

       merged.result_pages = this.mergeResultPages(merged.result_pages, rhs.result_pages, status_messages, options);

       return merged;
   },

   // merges resultset.result_pages
   //
   // pages are merged by putting pages where the order_range
   // overlaps into the new pages. The overlapping is only
   // taken into account once, thus the result may yield not
   // strictly ordered results. Overlapping pages produce pages
   // with *offset*, specifying where the display for the page
   // should start, e.g.
   //
   // {            starts: [ 0, 0 ], counts: [ 5, 5 ], page_number: 0, page: 1, order: 9, order_range: [9, null], original_page_numbers: [0, 0], current_page: true },
   // { offset: 5, starts: [ 0, 0 ], counts: [ 5, 5 ], page_number: 1, page: 2, order: 9, order_range: [9, null], original_page_numbers: [0, 0], current_page: true }
   //
   // pages are merged by concatenating their starts and counts
   // to associate the correct starts and counts with their services
   // pages missing from one side are padded with undefined
   //
   // to avoid having to pad all pages of one service, the merge only
   // happens if both sides have pages
   //
   // page_size is not merged, since it has to be the same for both sides
   mergeResultPages: function (lhs, rhs, status_messages, options) {
     var orderCompareFunction = Common.ORDER_TRANSFORMER[options.orderDirection](Common.genericCompare);

     var pagingFailed = !!(status_messages && status_messages.paging_failed);
     if (!lhs) return rhs;
     if (!rhs) return lhs;

     // if one side doesn't have pages, return the other one
     if (!(lhs.pages && lhs.pages.length > 0)) return rhs;
     if (!(rhs.pages && rhs.pages.length > 0)) return lhs;

     var numberOfPages = Math.max(lhs.pages.length, rhs.pages.length);
     var lhsNumberOfEntries = lhs.qeng_ids ? lhs.qeng_ids.length : 0;
     var rhsNumberOfEntries = rhs.qeng_ids ? rhs.qeng_ids.length : 0;
     var i;

     // create a shallow copy
     var merged = _.clone(lhs);

     // only merge if rhs has qeng_ids and pages
     // if we don't have any pages we don't need to update
     // qeng_ids, otherwise we would have to patch all
     // pages as well
     if (!merged.qeng_ids) {
       merged.qeng_ids = rhs.qeng_ids;
     } else {
       // concat does not change the original array (merged)
       merged.qeng_ids = merged.qeng_ids.concat(rhs.qeng_ids);
     }

     if (pagingFailed) {
       var pagingFailedForAllServices = false;
       var pagesServiceIds = _.flatten(_.pluck(merged.qeng_ids, "service_id"));
       var failedServiceIds = status_messages.paging_failed.service_ids;
       pagingFailedForAllServices = _.difference(pagesServiceIds, failedServiceIds).length === 0;

       if (pagingFailedForAllServices) {
         // TODO: retry
       }
     }

     merged.pages = this.mergeResultPagesBasedOnOrder(lhs.pages, lhsNumberOfEntries, rhs.pages, rhsNumberOfEntries, orderCompareFunction, merged.page_size);
     merged.page_count = merged.pages ? merged.pages.length : 0;

     // more_avail is true, if it is true for one
     merged.more_avail = merged.more_avail || rhs.more_avail;

     // there can't be multiple current_pages, remove the second one
     var currentPageFound = false;
     _.each(merged.pages, function (page, index) {
       if (page.current_page) {
         if (currentPageFound) {
           delete page.current_page;
         }
         currentPageFound = true;
       }
     }, []);

     // recalculate onFirstPage and onLastPage
     merged.onFirstPage = merged.pages[0].current_page === true;
     merged.onLastPage = merged.pages[merged.pages.length-1].current_page === true;

     return merged;
   },

   mergeResultPagesBasedOnOrder: function (lhsPages, lhsNumberOfEntries, rhsPages, rhsNumberOfEntries, orderCompareFunction, pageSize) {
     var pages = [];
     var lhsOffset = 0;
     var lhsPage;
     var rhsOffset = 0;
     var rhsPage;
     var offset;
     var skipLhs;
     var skipRhs;
     var i;
     var j;

     while (lhsOffset < lhsPages.length || rhsOffset < rhsPages.length) {
       lhsPage = lhsOffset < lhsPages.length && lhsPages[lhsOffset];
       rhsPage = rhsOffset < rhsPages.length && rhsPages[rhsOffset];

       if (!lhsPage) {
         // consumed all lhs pages => take rhs
         pages.push(this.mergeResultPage(null, lhsNumberOfEntries, rhsPage, rhsNumberOfEntries, orderCompareFunction));
         rhsOffset += 1;
       } else if (!rhsPage) {
         // consumed all rhs pages => take lhs
         pages.push(this.mergeResultPage(lhsPage, lhsNumberOfEntries, null, rhsNumberOfEntries, orderCompareFunction));
         lhsOffset += 1;
       } else if (
         lhsPage.order_range[1] === null
         || rhsPage.order_range[1] === null
         || (orderCompareFunction(lhsPage.order_range[0], rhsPage.order_range[0]) >= 0 && orderCompareFunction(lhsPage.order_range[0], rhsPage.order_range[1]) <= 0)
         || (orderCompareFunction(rhsPage.order_range[0], lhsPage.order_range[0]) >= 0 && orderCompareFunction(rhsPage.order_range[0], lhsPage.order_range[1]) <= 0)
       ) {
         // overlapping pages =>
         // add all rhs pages with the same state to all lhs pages with same state
         offset = 0;
         skipLhs = 0;
         for (i=lhsOffset; i<lhsPages.length && lhsPages[i].original_page_numbers[0] === lhsPage.original_page_numbers[0]; i++) {
           for (j=rhsOffset; j<rhsPages.length && rhsPages[j].original_page_numbers[0] === rhsPage.original_page_numbers[0]; j++) {
             pages.push(this.mergeResultPage(lhsPage, lhsNumberOfEntries, rhsPage, rhsNumberOfEntries, orderCompareFunction));
             if (offset > 0) {
               pages[pages.length-1].offset = offset;
             }
             offset += pageSize;
           }
           skipLhs++;
         }

         // add all rhs pages with the same state at the end as new pages containing the additional results
         skipRhs = 0;
         for (j=rhsOffset; j<rhsPages.length && rhsPages[j].original_page_numbers[0] === rhsPage.original_page_numbers[0]; j++) {
           pages.push(this.mergeResultPage(lhsPage, lhsNumberOfEntries, rhsPage, rhsNumberOfEntries, orderCompareFunction));
           pages[pages.length-1].offset = offset;
           offset += pageSize;
           skipRhs++;
         }

         // skip processed pages
         lhsOffset += skipLhs;
         rhsOffset += skipRhs;
       } else {
         // not overlapping => take next page with more relevant order
         if (orderCompareFunction(lhsPages[lhsOffset].order, rhsPages[rhsOffset].order) < 0) {
           pages.push(this.mergeResultPage(lhsPage, lhsNumberOfEntries, null, rhsNumberOfEntries, orderCompareFunction));
           lhsOffset += 1;
         } else {
           pages.push(this.mergeResultPage(null, lhsNumberOfEntries, rhsPage, rhsNumberOfEntries, orderCompareFunction));
           rhsOffset += 1;
         }
       }
     }

     // adapt page numbers
     _.each(pages, function (page, index) {
       page.page_number = index;
       page.page = page.page_number + 1;
     });

     return pages;
   },

   nonNullOrMinValue: function (lhs, rhs, orderCompareFunction) {
     if (lhs === null) return rhs;
     if (rhs === null) return lhs;

     return Common.Properties.minValue(lhs, rhs, orderCompareFunction);
   },

   mergeResultPage: function (lhs, lhsNumberOfEntries, rhs, rhsNumberOfEntries, orderCompareFunction) {
     if (!lhs) lhs = { starts: new Array(lhsNumberOfEntries), counts: new Array(lhsNumberOfEntries), order: null, order_range: [null, null], original_page_numbers: new Array(lhsNumberOfEntries) };
     if (!rhs) rhs = { starts: new Array(rhsNumberOfEntries), counts: new Array(rhsNumberOfEntries), order: null, order_range: [null, null], original_page_numbers: new Array(rhsNumberOfEntries) };

     var page = {
       starts: lhs.starts.concat(rhs.starts),
       counts: lhs.counts.concat(rhs.counts),
       page_number: _.isNumber(lhs.page_number) ? lhs.page_number : rhs.page_number,
       original_page_numbers: lhs.original_page_numbers.concat(rhs.original_page_numbers),
       order: this.nonNullOrMinValue(lhs.order, rhs.order, orderCompareFunction),

       // add synthesized properties
       page: lhs.page || rhs.page,
       order_range: [
         this.nonNullOrMinValue(lhs.order_range[0], rhs.order_range[0], orderCompareFunction),
         Common.Properties.minValue(lhs.order_range[1], rhs.order_range[1], Common.ORDER_TRANSFORMER["DESCENDING"](orderCompareFunction))
       ]
     };

     // assumption:
     // we don't send requests to services that have less then
     // the number of requested pages, so current_page can't differ
     if (lhs.current_page || rhs.current_page) {
       page.current_page = true;
     }

     return page;
   },

   // order_next_result can also be merged if only one service supports it
   // it is only set, if termination_cause is COUNT_LIMIT
   mergeOrderNextResult: function (lhs, lhs_per_service_dataset, rhs, rhs_per_service_dataset, options) {
     if (!lhs) return rhs;
     if (!rhs) return lhs;

     return (Common.ORDER_TRANSFORMER[options.orderDirection](Common.genericCompare))(lhs, rhs) < 0 ? lhs : rhs;
   },

   //
   // Changed merge semantics:
   //   we merge the new object with the existing, so that
   //   we do not have aliases in cached submodels, that would implicitly
   //   get updated.
   //
   mergeSearchResponse: function(lhs, rhs, options) {
     lhs = lhs || {};
     rhs = rhs || {};

     var merged;
     if (!lhs.search_request) {
       merged = _.clone(rhs);
       // TODO: Note that nextPage behaves problematic if we ignore this here
       //       seems that results are aliased.
       // TODO: find a better way of knowing initialization
       merged.status_messages = Common.StatusMessages.merge(merged.status_messages, rhs.status_messages);
     } else {
       merged = _.clone(lhs);
       // we need the status_messages for parsing the resultset, make sure they are set up
       merged.status_messages = Common.StatusMessages.merge(merged.status_messages, rhs.status_messages);
       if (!_.isUndefined(rhs.estimated_count)) {
         merged.estimated_count = merged.estimated_count ? merged.estimated_count + rhs.estimated_count : rhs.estimated_count;
       }

       merged.is_about = merged.is_about || rhs.is_about;

       // merged.search_request = rhs.search_request ? rhs.search_request : merged.search_request;
       merged.available_facets = this.mergeAvailableFacets(merged.available_facets, rhs.available_facets);
       merged.available_properties = this.mergeAvailableProperties(merged.available_properties, rhs.available_properties);
       merged.resultset = this.mergeResultSet(merged.resultset, rhs.resultset, options, merged.status_messages);
       merged.facets = this.mergeFacets(merged.facets, rhs.facets);
       merged.orderable = this.mergeOrderables(merged.orderable, rhs.orderable);

       // merged.resultset = this.mergeViews(merged.views, rhs.views, options);
       merged.alternatives = this.mergeAlternatives(merged.alternatives, rhs.alternatives, options);
       if (merged.search_request) {
         merged.show_query_spelling_alternatives = !merged.estimated_count || merged.extimated_count <= merged.search_request.alternatives_query_spelling_max_estimated_count ;
       }

       merged.order_direction_available = (merged.order_direction_available === true && rhs.order_direction_available === true);
     }
     return merged;
   },

   //
   //
   merge: function(lhs, rhs, options) {
     var options = options || {};
     // merge can also be called with a path.
     // then we have to detect the right subtype.
     if (options.path != null) {
       var type = this.getTypeFromPath(options.path);
       if (!type) {
         throw new Error("Merge failed. Unable to detect type from path " + JSON.stringify(options.path));
       }
       var mergeFunction = this.getMergeFunctionByType(type);

       options = _.clone(options);
       delete options.path;
       return mergeFunction(lhs,rhs,options);
     }

     return this.mergeSearchResponse.apply(this, arguments);
   }

   });

   _.extend(SearchOutputModel.prototype, SearchResponse);


   /**
    * @namespace common
    */
   /**
    * @typedef PropertyDefinition
    * @memberof common
    * @type {Object}
    * @property {string} name
    * @property {string[]} formats  Either <code>'HTML', 'VALUE', 'PROPERTY' </code>
    */

   /**
      @namespace search
    */
   /**
    * @typedef SearchRequest
    * @memberof search
    * @type  {Object}
    * @property {string} name  identifies the search view name
    * @property {number} count specifies the result count
    * @property {number} content_sample_length
    * @property {string} orderby
    * @property {object} user  specifies user specific parameters
    * @property {QueryExpr} user.query  specifies the user query
    * @property {common.PropertyDefinition[]} facets  the requested filtered facets
    * @property {common.PropertyDefinition[]} properties  the requested properties
    */


   var SearchRequest = {

       parse: function (attributes) {
          var result = {};

         for (var name in attributes) {
           if (!attributes.hasOwnProperty(name)) {
             continue;
           }
           if (name === "facets" || name === "properties") {
             result[name] = this.parsePropertyDefinitions(attributes[name]);
           }
           else if (name === "boostings") {
              result[name] = this.parseBoostings(attributes[name]);
           }
           else if (name === "user") {
              result[name] = this.parseUser(attributes[name]);
              if (result[name].query) {
                result[name].query = this.parseQueryExpr(result[name].query);
              }
           }
           else if (name === "source_context") {
              result[name] = this.parseConstraints(attributes[name]);
           }
           else if (name == "pattern_constraints") {
             result[name] = this.parsePatternConstraints(attributes[name]);
           }
           else {
             result[name] = attributes[name];
           }
         }
         return result;

       },

       // facets, properties
       jsonifyPropertyDefinitions: function(properties) {
         var that = this;
         return _.map(Common.propertyListToArray(properties, "name"), function(property) {
           if (!_.isEmpty(property.properties)) {
             property.properties = that.jsonifyPropertyDefinitions(property.properties);
           }
           else if (property.properties) {
             delete property.properties;
           }
           return property;
         });
       },


       jsonifyConstraints: function (constraintsParent) {
         var that = this,
             result = _.clone(constraintsParent);

         result.constraints = Common.propertyListToArray(result.constraints);
         result.constraints = _.map(result.constraints, function (constraint) {
           constraint = _.clone(constraint);
           constraint.filtered = Common.propertyListToArray(constraint.filtered);
           if (!constraint.filtered) delete constraint.filtered;
           constraint.filter_base = Common.propertyListToArray(constraint.filter_base);
           if (!constraint.filter_base) delete constraint.filter_base;
           return constraint;
         });

         return result;
       },

         jsonifyPatternConstraints: function (constraintsParent) {
           var that = this,
               result = _.clone(constraintsParent);

           result = Common.propertyListToArray(result);
           result = _.map(result, function (constraint) {
             constraint = _.clone(constraint);
             if (constraint.source) {
               constraint.source.filtered = Common.propertyListToArray(constraint.source.filtered);
               if (!constraint.source.filtered) delete constraint.source.filtered;
               else {
                 constraint.source.filtered = _.map(constraint.source.filtered, function(filtered) {
                   return that.jsonifyQueryExpr(filtered);
                 });
               }
               constraint.source.filter_base = Common.propertyListToArray(constraint.source.filter_base);
               if (!constraint.source.filter_base) delete constraint.source.filter_base;
               else {
                 constraint.source.filter_base = _.map(constraint.source.filter_base, function(filtered) {
                   return that.jsonifyQueryExpr(filtered);
                 });
               }
             }

             return constraint;
           });
           // console.log(JSON.stringify(result));
           return result;
         },


         jsonifyQueryExpr: function(query) {
           // and: {a: {or: {b: {unparsed: "test"} ... transforms to
          //    and: [{id: a, or: [{id:b, unparsed: "test"}]

           var that = this,
               result = _.clone(query);

           _.each(_.keys(result), function(key) {
             if (key == "and" || key == "or" ) {
               var exprs = result[key];
               if (_.isObject(exprs) && !_.isArray(exprs)) {
                 exprs = Common.propertyListToArray(exprs);
               }
               result[key] = _.map(exprs, that.jsonifyQueryExpr, that);
             }
           });
           return result;
         },

         parsePropertyDefinitions: function(properties) {
         var that = this;
         return Common.arrayToPropertyList(
                _.map(properties,
                 function(property) {
                   if (_.isArray(property.properties)) {
                     property.properties = that.parsePropertyDefinitions(property.properties);
                   }
                   return property;
                 }), "name");
       },

       parseBoostings: function(properties) {
         return Common.arrayToPropertyList(properties);
       },

       parsePatternConstraints: function(constraintsParent) {
         var that = this,
             result = _.clone(constraintsParent);

         result = Common.arrayToPropertyList(result);
         result = _.map(result, function (constraint) {
           constraint = _.clone(constraint);
           if (constraint.source) {
             constraint.source.filtered = Common.arrayToPropertyList(constraint.source.filtered);
             if (!constraint.source.filtered) delete constraint.source.filtered;
             else {
               constraint.source.filtered = _.map(constraint.source.filtered, function(filtered) {
                 return that.jsonifyQueryExpr(filtered);
               });
             }
             constraint.source.filter_base = Common.arrayToPropertyList(constraint.source.filter_base);
             if (!constraint.source.filter_base) delete constraint.source.filter_base;
             else {
               constraint.source.filter_base = _.map(constraint.source.filter_base, function(filtered) {
                 return that.jsonifyQueryExpr(filtered);
               });
             }
           }

           return constraint;
         });
         // console.log(JSON.stringify(result));
         return result;
       },

       parseConstraints: function (constraintsParent) {
         var that = this,
             result = _.clone(constraintsParent);

         if (!result.constraints) {
           return result;
         }

         if (_.isArray(result.constraints)) {
           for (var i = 0; i < result.constraints.length; ++i) {
             var constraint = result.constraints[i];
             if (constraint.filtered && _.isArray(constraint.filtered))
               constraint.filtered =  Common.arrayToPropertyList(constraint.filtered);
             if (constraint.filter_base && _.isArray(constraint.filter_base))
               constraint.filter_base =  Common.arrayToPropertyList(constraint.filter_base);
           }
           result.constraints = Common.arrayToPropertyList(result.constraints);
         }
         return result;
       },

       parseQueryExpr: function(query) {

         var that = this,
             result = _.clone(query);

         _.each(_.keys(result), function(key) {
           if (key == "and" || key == "or" ) {
             var exprs = result[key];
             if (_.isArray(exprs)) {
               exprs = Common.arrayToPropertyList(exprs);
             }
             if (_.isObject(exprs)) {
               result[key] = that.parseQueryExpr(exprs);
             }
             result[key] = exprs;
           }
         });
         return result;

       },

       parseUser: function(attributes) {
         if (!attributes) return attributes;
         var result = this.parseConstraints(attributes);
         if (attributes.query) {
           result["query"] = this.parseQueryExpr(attributes.query);
         }
         return result;
       },


       jsonifyBoostings: function(properties) {
         return Common.propertyListToArray(properties);
       },

       // maps attributes to the protocol buffer representation
       jsonify: function(attributes) {
         var result = {};

         for (var name in attributes) {
           if (!attributes.hasOwnProperty(name)) {
             continue;
           }
           if (name === "facets" || name === "properties") {
             result[name] = this.jsonifyPropertyDefinitions(attributes[name]);
           }
           else if (name === "boostings") {
              result[name] = this.jsonifyBoostings(attributes[name]);
           }
           else if (name === "user") {
              result[name] = this.jsonifyConstraints(attributes[name]);
              if (result[name].query) {
                result[name].query = this.jsonifyQueryExpr(result[name].query);
              }
           }
           else if (name === "source_context") {
              result[name] = this.jsonifyConstraints(attributes[name]);
           }
           else if (name == "pattern_constraints") {
             result[name] = this.jsonifyPatternConstraints(attributes[name]);
           }
           else {
             result[name] = attributes[name];
           }
         }
         return result;

       }


   };

  var SearchInputModel = Search.SearchInputModel = TreeModel.extend({

     toJSON: function(attrs) {
       if (attrs == null)
       var attrs = this.attributes;
       attrs = _.clone(attrs);
       var json = this.jsonify(attrs);
       // console.log("SeachRequest: ", JSON.stringify(json, null, 2));
       return json;
     },

     initialize: function(attributes, options) {
       // this shall indicate default values of features.

       // Attention:
       //   if silent is true then this changes will be recorded and
       //   trigger change immediately when activating the computed
       //   wiring.

       if (this.get("sort_date_facets_by_value") == null) {
         this.set("sort_date_facets_by_value", true, {silent: false});
       }

       TreeModel.prototype.initialize.apply(this ,arguments);
     }

     // resetActionState: function() {
     //   for (viewID in this.attributes.views) {
     //     if (this.attributes.views[viewID].paging) {
     //       delete this.attributes.views[viewID].paging;
     //       // console.log("Deleted paging from view " + viewID);
     //     }
     //   }
     //}
   });

   // return an array with all the elements at the given positions
   function getElements(array, indexList) {
     var result = [];
     _.each(indexList, function (index) {
        result.push(array[index]);
     });
     return result;
   }

  _.extend(SearchInputModel.prototype, SearchRequest);

  var SearchServiceStub = Search.SearchServiceStub = Stub.extend({
    path: "search",

    call: function(channel, searchRequest, responseObserver) {
      // this is per request type
      // possibility to intercept with request and
      // perform e.g. short cutting.

      // use channel.id to know the id of the channel
      // console.log("SearchServiceStub.call for channel", channel.id, searchRequest);

      var filterResultPagesResult;
      var adaptedSearchRequest = _.clone(searchRequest);
      adaptedSearchRequest.path = this.path;

      // TODO: abort request if no paging_state for channel, but other paging_states available???
      adaptedSearchRequest.paging_states = _.select(adaptedSearchRequest.paging_states, function (paging_state) {
        return paging_state && paging_state.service_id === channel.id;
      });

      // adapt result_pages for each channel
      //
      // if the selected page (current_page: true) is not available for the channel,
      //   send a response containing only the requested result_pages,
      //   so we can page back to a page available for that channel
      //   thus the requested result_pages have to contain
      //   all the result_pages for this channel from the model
      if (adaptedSearchRequest.result_pages) {
        filterResultPagesResult = this.filterResultPages(adaptedSearchRequest.result_pages, channel.id);

        if (!filterResultPagesResult) {
          // no result_pages available for the current channel => abort
          return;
        }

        if (filterResultPagesResult.emitResponse) {
          // emit the incoming result_pages for the given channel as response
          return this.emitSuccessResponse({
              status_messages: [{
                id: "paging_failed",
                hidden: true
              }],
              search_request: adaptedSearchRequest,
              resultset: {
                result_pages: filterResultPagesResult.result_pages
              }
            }, channel, responseObserver);
        } else {
          // send the result_pages filtered by service_id
          adaptedSearchRequest.result_pages = filterResultPagesResult.result_pages;
        }
      }

      return Stub.prototype.call.apply(this, [channel, adaptedSearchRequest, responseObserver]);
    },

    // send a success response with the given data from the given channel
    emitSuccessResponse: function (data, channel, responseObserver) {
      var promise = new Channel.DeferredCallFinished(channel);
      setTimeout(function () {
        channel.success(data, promise, responseObserver);
      });
      return promise;
    },

    // filters result_pages by service_id
    //
    // returns:
    //   undefined: if there are no entries for the given service_id
    //   { emitResponse: true, result_pages: { <result_pages filtered by service_id> } }: if the page is not available for this service_id
    //              (the entries for this service_id are empty)
    //   { result_pages: { <first page with current_page: true, filtered by service_id> }}: if there are
    //              correct entries for the service_id
    //
    // for every entry in qeng_ids with the same service_id, copy the sections of starts and counts
    //
    // input:
    // {
    //   "qeng_ids": [
    //      { "service_id": "https://example1.mindbreeze.com/apps/client/../../api/v2/", "qeng_id": "https://inspire-012345-6789-abcdef:23301", "digest": "01234" },
    //      { "service_id": "https://example1.mindbreeze.com/apps/client/../../api/v2/", "qeng_id": "https://inspire-012345-6789-abcdef:23300", "digest": "01234" }
    //      { "service_id": "https://example2.mindbreeze.com/apps/client/../../api/v2/", "qeng_id": "https://inspire-012345-6789-abcdef:23302", "digest": "01234" }
    //    ],
    //    "pages": [
    //      { "starts": [ 0, 0, 0 ], "counts": [ 0, 5, 5 ], "page_number": 0 },
    //      { "starts": [ 0, 5, undefined ], "counts": [ 0, 3, undefined ], "page_number": 1, "current_page": true }
    //    ]
    // }
    //
    // output for example1:
    //
    // {
    //   "result_pages": {
    //     "qeng_ids": [
    //        { "service_id": "https://example1.mindbreeze.com/apps/client/../../api/v2/", "qeng_id": "https://inspire-012345-6789-abcdef:23301", "digest": "01234" },
    //        { "service_id": "https://example1.mindbreeze.com/apps/client/../../api/v2/", "qeng_id": "https://inspire-012345-6789-abcdef:23300", "digest": "01234" }
    //      ],
    //      "pages": [
    //        { "starts": [ 0, 5 ], "counts": [ 0, 3 ], "page_number": 1, "current_page": true }
    //      ]
    //   }
    // }
    //
    // output for example2:
    //
    // {
    //   "emitResponse": true,
    //   "result_pages": {
    //     "qeng_ids": [
    //        { "service_id": "https://example2.mindbreeze.com/apps/client/../../api/v2/", "qeng_id": "https://inspire-012345-6789-abcdef:23302", "digest": "01234" }
    //      ],
    //      "pages": [
    //        { "starts": [ 0 ], "counts": [ 5 ], "page_number": 0 },
    //      ]
    //   }
    // }
    filterResultPages: function (result_pages, service_id) {
      if (!result_pages) return;

      var matchingIndexList = [];
      var page;
      var pageAvailable = false;
      var filteredQengIds = _.select(result_pages.qeng_ids, function (qeng_id, index) {
        if (qeng_id.service_id === service_id) {
          matchingIndexList.push(index);
          return true;
        }
      }, []);

      // service not found, abort
      if (matchingIndexList.length < 1) return;

      // shallow clone
      result_pages = _.clone(result_pages);
      result_pages.qeng_ids = filteredQengIds;

      page = _.find(result_pages.pages, function (page) { return page.current_page; });
      if (!page) return;

      // shallow clone
      page = _.clone(page);
      page.starts = getElements(page.starts, matchingIndexList);
      page.counts = getElements(page.counts, matchingIndexList);
      delete page.order;

      // take the original_page_number from the first matching index
      page.page_number = page.original_page_numbers[matchingIndexList[0]];

      if (_.isNumber(page.starts[0])) {
        pageAvailable = true;
      }

      // page found, return filtered result_pages
      if (pageAvailable) {
        result_pages.pages = [page];
        return { result_pages: result_pages }
      }

      // remove other services elements from arrays and only return pages without offset,
      // since pages with offsets exist without offsets as well
      result_pages.pages = _.select(_.map(result_pages.pages, function (page) {
        page = _.clone(page);
        page.starts = getElements(page.starts, matchingIndexList);
        page.counts = getElements(page.counts, matchingIndexList);
        page.original_page_numbers = getElements(page.original_page_numbers);
        return page
      }), function (page) {
        return page.counts.length && _.isNumber(page.starts[0]) && !page.offset;
      });

      _.each(result_pages.pages, function (page, index) {
        page.page_number = index;
      });

      // page does not contain starts and counts for service_id, let caller know
      return { emitResponse: true, result_pages: result_pages }
    }

  });

  // PagingCache caches search models for paging directly
  //
  // * add search models for pages with set(page, model)
  // * retrieve search models for a page with at(page)
  //
  // The cache has a limit of used models to avoid high memory
  // usage. The limit is MAX_PAGES and is avaiable per instance.
  // The limit is enforced in the *set* calls.
  //
  // The cache resets itself if the input model changes.
  var PagingCache = Search.PagingCache = function PagingCache() {
    this.initialize.apply(this, arguments);
  }

  PagingCache.prototype = {
    MAX_PAGES: 1,

    initialize: function (inputModel) {
      // register event on inputModel for automatic reset
      // thus we don't need to destroy the paging cache
      // separatly, since it can't exist longer than the
      // search model
      this.reset = _.bind(this.reset, this);
      inputModel.listenTo(inputModel, "change", this.reset);
      this.reset();
    },

    reset: function () {
      var i;

      this.modelIdSet = [];

      if (this.models) {
        for (i=0; i<this.models.length; i++) {
          this.cleanupModel(this.models[i]);
        }
      }

      this.models = [];
    },

    at: function (page) {
      return this.models[page];
    },

    set: function (page, model) {
      var modelIndex = _.indexOf(this.modelIdSet, model.cid)
      if (modelIndex >= 0) {
        this.modelIdSet.splice(modelIndex, 1);
      }
      this.modelIdSet.push(model.cid);
      this.models[page] = model;
      this.cleanup();
    },

    cleanup: function () {
      var positionToRemove;
      var modelIdsToDelete;
      var i;

      if (this.modelIdSet.length > this.MAX_PAGES) {
        modelIdsToDelete = this.modelIdSet.splice(0, this.modelIdSet.length - this.MAX_PAGES);
        for (i=0; i<this.models.length; i++) {
          if (this.models[i] && _.contains(modelIdsToDelete, this.models[i].cid)) {
            this.cleanupModel(this.models[i]);
            delete this.models[i];
          }
        }
      }
    },

    cleanupModel: function (model) {
      if (!model) return;
      model.destroy();
    }

  };

  // This mimics a collection of models which properties are defined using the properties
  // argument. More advanced projection other then just specific arguments are TBD.
  // This collection object should also be factored out of the search context in order
  // to reuse it.
  //
  // The collection listens on "change" of output and recomputes the elments. If the arguments have
  // a unique id (as in the search results) case the collection thus can also compute which of the
  // elements have been changed, removed, added. THis is also the order in which this should be
  // emited.
  // (1) trigger changes
  // (2) trigger removes
  // (3) trigger adds
  //
  // these events are also sent to the inner model
  // event: "add"     model, collection, {at: position}
  // event: "remove"  model, collection, options
  // event: "change"  model, options
  //
  //
  // options:
  //
  // nestedProperties: array of property names that keep their nested properties. default: ["mes:nested"]
  // limitToPageSize: if true and the resultset contains result_pages.page_size, the number of results
  //                  in the collection will not exceed page_size
  /**
  * @typedef ResultCollection
  * @memberof api/v2/search
  * @type  {Object}
  */

  var ResultCollection = Search.ResultCollection = function(properties, options) {
    this.cid = _.uniqueId('c');
    this.options = options || {};
    this.options.nestedProperties = this.options.nestedProperties || ["mes:nested"];
    this._updateProperties(properties||{});

    this._modelMap = {};
    this.models = [];
  }

  _.extend(ResultCollection.prototype, Backbone.Events, {


    _updateProperties: _updateProperties,

    setView: function(searchModel) {
      this.searchModel = searchModel;
      this.options.enableImmediateDisplayOfFederatedResults = searchModel && searchModel.options && searchModel.options.enableImmediateDisplayOfFederatedResults;
      this.resultset = searchModel.submodel("resultset");

      if (this.options.enableImmediateDisplayOfFederatedResults) {
        this.listenTo(this.resultset.output, "change", this._onChangeOutput);
      } else {
        this.listenTo(this.searchModel, "computed", function (searchModel, options) {
            this.done = true;
            clearTimeout(this.timeout);
            this._onChangeOutput(this.resultset.output);
        });
        this.listenTo(this.searchModel, "change", function (searchModel, options) {
            this.changed = true;
            if (!this.done) {
              if (new Date() - this.startTime > Search.DISPLAY_TIMEOUT) {
                that._onChangeOutput(that.resultset.output);
                that.trigger("updated")
              }
            }
        });
        this.listenTo(this.searchModel, "compute", function () {
            this.done = false;
            this.changed = false;
            this.startTime = new Date();
            clearTimeout(this.timeout);
            this.timeout = setTimeout(function () {
                if (!that.done && that.changed) {
                  that._onChangeOutput(that.resultset.output);
                  that.trigger("updated")
                }
              }, Search.DISPLAY_TIMEOUT);
        });
        this.listenTo(this.searchModel, "reset", function (searchModel, options) {
            this.done = true;
        });
      }


      var that = this;
      this.listenTo(this.resultset.output, "reset", this._onResetOutput);
      // initial call change to detect what is already there
      this._onChangeOutput(this.resultset.output);
    },

    // connect: function(registry, options) {
    //   this.view = registry.model;
    //   this.listenTo(this.view.output, "change", this._onChangeOutput);
    //   this.listenTo(this.view.output, "reset", this._onResetOutput);

    // },

    change: function(options) {
      options = options || {};
      if (this.searchModel) {
        this.searchModel.updateResultCollection(this, options);
      }
    },

    addProperty: function(properties, options) {
      var keys = _.keys(properties);
      for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        this.originalProperties[key] = properties[key];
      }
      if (keys.length > 0) {
        this._updateProperties(this.originalProperties);
        this.change(options);
      }
    },

    removeProperty: function(propertyName, options) {
      if (this.originalProperties[propertyName]) {
        delete this.originalProperties[propertyName];
        this._updateProperties(this.originalProperties);
        this.change(options);
      }
    },

    setProperties: function(properties, options) {
      this._updateProperties(properties);
      this.change(options);
    },

    dispose: function() {
      this.stopListening();
      if (this.searchModel) {
        this.searchModel.removeResultCollection(this);
      }
      if (this.resultset) {
        this.resultset.dispose();
      }
      this.searchModel = null;
    },


    clear: function(options) {
      for (var k = 0; k < this.models.length; k++) {
        var model = this.models[k];
        if (!model) continue;
        var modelID = model.output.id;
        model.trigger('remove', model, this, options);
        this.stopListening(model);
        model.destroy();
      }
      this._modelMap = {};
      this.models = [];
    },

    _modelEvent: function(eventName, model, collection, option) {
      // console.log("Model event", eventName, "received.");
      if ((eventName == "add" || eventName == "remove") && collection != this) return;
      this.trigger.apply(this, arguments);
    },

    _onResetOutput: function(output) {
      this.trigger("reset", this);
      if (!this.options.enableImmediateDisplayOfFederatedResults) {
        this._onChangeOutput();
      }
    },

    // called on change
    _onChangeOutput: function(output, options) {
      // console.log("results " + JSON.stringify(output.get(), null, 2));
      try {
      var results = output && output.get("results") || [];
      var pageSize = output && output.get("result_pages.page_size");
      var orderDirection = output && output.get("order_direction") || "DESCENDING";
      var models = [];
      var adds = [];
      var modelMap = {};
      var modelIds = _.map(this.models, function (model) { return model.get("id"); });
      var deletes = [].concat(this.models);

      // if result_pages are available, remove results not in pageSize
      if (pageSize && this.options.limitToPageSize) {
        results = results.slice(0, pageSize);
      }

      var orderNextResult = output && output.get("order_next_result");
      var compareFunction = (Common.ORDER_TRANSFORMER[orderDirection] || Common.ORDER_TRANSFORMER["DESCENDING"])(Common.genericCompare);
      if (this.options.enableImmediateDisplayOfFederatedResults || orderNextResult === undefined) {
        compareFunction = function () {
          return 1; // display everything
        }
      }

      for (var i = 0 ; i < results.length && (results[i].order === undefined || results[i].order === null || compareFunction(orderNextResult, results[i].order) >= 0 || results[i]._displayed); ++i) {
        var result = results[i];
        result._displayed = true;
        var atts = {};
        var propdefs = {};
        atts.id = result.id;
        // TODO: clone / will be overwritten if location is available as property !!!!?
        atts.location = result.location;
        // TODO: clone / will be overwritten if relevance_score is available as property !!!!?
        atts.relevance_score = result.relevance_score;
        atts["mes:group"] = result.group;
        // console.log("result.id",  result.id);
        if (!result.properties) continue;
        var keys = _.keys(this.originalProperties);
        var that = this;
        _.each(keys, function(propName) {

          var propertyDef  = that.originalProperties[propName];
          var propRoot     = propertyDef.root;
          var propPathRest = propertyDef.path;
          var propFormat   = propertyDef.format;

          var prop = result.properties[propRoot];
          if (prop !== undefined) atts[propRoot] = prop;
          propdefs[propName] = {format: propFormat};
        });

        var model = this._modelMap[result.id];
        var modelIndex = _.indexOf(modelIds, result.id);
        if (model && modelIndex == i && _.isEqual(result.group, model.get("mes:group")) ) {
          if (model.output._source != result) {
            // triggers change
            model.output.reset(atts, options);
            model.output._source = result;
          }
          deletes = _.without(deletes, model);
        }
        else {
          var outputModel = new PropertiesModel(atts, {propertyDefinitions: propdefs });
          outputModel._source = result;
          var wiring = null;
          var input;

          if (this.searchModel != null) {
            wiring = this.searchModel.wiring;
            input = this.searchModel.input;
          } else {
            wiring = new ComputeWiring(new TreeModel(), outputModel);
            input = wiring.input;
          }
          model = new ComputedModel(wiring, {input: input, output: outputModel});
          this.listenTo(model, 'all', this._modelEvent);
          adds.push(model);
        }
        model.channel = result.channel;
        models.push(model);
        modelMap[result.id] = model;
      }
      for (var i = 0 ; i < results.length; ++i) {
        if (!modelMap[results[i].id]) {
          delete results[i]._displayed;
        }
      }

      this.models = models;
      this._modelMap = modelMap;

      for (var k = 0; k < deletes.length; k++) {
        var model = deletes[k];
        if (!model) continue;
        if (model.output) model.output._source = null;
        model.trigger('remove', model, this, options);
        this.stopListening(model);
        model.destroy();
      }
      var k = 0;
      for (var n = 0; n < models.length; n++) {
        var model = models[n];
        if (adds[k] == model) {
          k++;
          model.trigger('add', model, this, _.extend({at: n}, options));
        }
      }

      _.forEach(this.models, function (model, index) {
        model.position = index;
      });

      } catch (e) { if (console && console.error) console.error("Error occured.", e.stack); throw e; }
    },

    get: function (id) {
      return this._modelMap[id];
    }
  });

  /*
   * I want to register for a particular facet:
   *
   */
  var FACET_VALUE_PROPERTY = "value";
  var FacetValueCollection = Search.FacetValueCollection = function(name, properties, options) {
    this.cid = _.uniqueId('c');

    this.facets = {};
    this.name = name;

    if (properties[FACET_VALUE_PROPERTY]) {
      this.facets[name] = {format: properties[FACET_VALUE_PROPERTY].format};
    } else {
      this.facets[name] = {format: "HTML"};
    }

    options = options || {};
    this.comparator = options.comparator;
    this.usePath = options.usePath;
    this.options = options;

    // properties are currently not used
    this._updateProperties(properties || {});

    this._modelMap = {};
    this.models = [];
  }

  _.extend(FacetValueCollection.prototype, Backbone.Events, {
    _updateProperties: _updateProperties,

    setView: function(searchModel) {
      this.searchModel = searchModel;
      this.facet = searchModel.submodel(["facets", this.name]);
      this.listenTo(this.facet.output, "change", this._onChangeOutput);
      this.listenTo(this.facet.output, "reset", this._onResetOutput);
      // initial call change to detect what is already there
      this._onChangeOutput(this.facet.output);
    },

    dispose: function(options) {
      this.facet.dispose();
      this.stopListening();
      if (this.view) {
        this.view.removeFacet(this, options);
      }
      this.view = null;
    },

    clear: function(options) {
      for (var k = 0; k < this.models.length; k++) {
        var model = this.models[k];
        if (!model) continue;
        var modelID = model.output.id;
        model.trigger('remove', model, this, options);
        this.stopListening(model);
        model.destroy();
      }
      this._modelMap = {};
      this.models = [];
    },

    _modelEvent: function(eventName, model, collection, option) {
      // console.log("Model event", eventName, "received.");
      if ((eventName == "add" || eventName == "remove") && collection != this) return;
      this.trigger.apply(this, arguments);
    },

    _onResetOutput: function(output) {
      this.trigger("reset", this);
    },

    // called on change
    _onChangeOutput: function(output) {
      // console.log("name: " + this.facets[0] );
      // console.log("facets " + JSON.stringify(output.get("facets"), null, 2));
      try {
      var options = {};

      var elts = (this.usePath ? output.get(["facets", this.name, "entries"]) : output.get("entries")) || [];
      var orderCriteria = (this.usePath ? output.get(["facets", this.name, "order_criteria"]) : output.get("order_criteria")) || "COUNT";

      var models = [];
      var adds = [];
      var modelMap = {};
      var deleteMap = {};
      var dataType = undefined;

        // console.log("results " + JSON.stringify(results, null, 2));
        for (var i = 0 ; i < elts.length; ++i) {
          var element = elts[i];
          // direct copy of elements
          var that = this;
          var atts = _.clone(element);
          // atts["@pos"] = i;

          if (dataType === undefined) {
            if (_.isDate(atts[FACET_VALUE_PROPERTY])) {
              dataType = "Date"
            } else if (_.isString(atts[FACET_VALUE_PROPERTY])) {
              dataType = "String"
            } else {
              dataType = "unknown";
            }
          }

          atts.facet = this.name;
          switch (this.facets[this.name].format) {
           case "HTML":
            atts[FACET_VALUE_PROPERTY] = atts.html;
            break;
           case "VALUE":
            atts[FACET_VALUE_PROPERTY] = atts[FACET_VALUE_PROPERTY];
            break;
           default:
            atts[FACET_VALUE_PROPERTY] = atts.html;
            break;
          }
          atts.id = atts[FACET_VALUE_PROPERTY];
          // if (element.excluded) {
          //  atts.id += "_excluded";
          // }
          var entries = atts.entries;
          var subid = this.name + "." + atts.id;
          var sub = {
            facets: {
            }
          };
          sub.facets[subid] = { entries: entries };
          sub = new ReadOnlyTreeModel(sub);
          if (atts.entries) {
            atts.entries = new FacetValueCollection(subid, this.properties, {
              comparator: this.comparator,
              usePath: true
            });
          }

          var model = this._modelMap[atts.id];
          if (model && (orderCriteria == "COUNT" && (atts.excluded || model.count == atts.count))) {
            if (model.get("entries")) {
              model.get("entries")._onChangeOutput(sub);
              atts.entries = model.get("entries");
            } else if (atts.entries) {
              atts.entries._onChangeOutput(sub);
            }

            // triggers change
            (model.output || model).reset(atts);
            // TODO: reset entries as well
          }
          else {
            if (atts.entries) {
              atts.entries._onChangeOutput(sub);
            }
            if (model) {
              deleteMap[atts.id] = model;
            }

            var outputModel = PropertiesModel.fromAttsAndProperties(atts, atts.properties, this.originalProperties);
            if (this.searchModel == null || this.searchModel.wiring == null) {
              model = outputModel;
            }
            else {
              model = new ComputedModel(this.searchModel.wiring, {input: this.searchModel.input, output: outputModel});
            }

            if (this.options.attributeDefinitions) {
              model = new AttributeProxyModel(model, this.options.attributeDefinitions);
            }

            this.listenTo(model, 'all', this._modelEvent);
            adds.push(model);
          }
          models.push(model);
          modelMap[atts.id] = model;
        }




      var previousModelMap = this._modelMap;
      var previousModels = this.models;
      this.models = models;
      this._modelMap = modelMap;

      this.sort();

        // Additional model elements
        if (this.options.allFacetValueAttributes) {
          var allFacetValueModel = new ReadOnlyTreeModel(this.options.allFacetValueAttributes);
          this.listenTo(allFacetValueModel, 'all', this._modelEvent);
          if (this.options.attributeDefinitions) {
            allFacetValueModel = new AttributeProxyModel(allFacetValueModel, this.options.attributeDefinitions);
          }
          adds.push(allFacetValueModel);
          models.unshift(allFacetValueModel);
          modelMap[this.options.allFacetValueAttributes.id] = allFacetValueModel;
        }

      for (var k = 0; k < previousModels.length; k++) {
        var model = previousModels[k];
        if (!model) continue;
        var modelID = (model.output || model).id;
        if (!modelMap[modelID] || deleteMap[modelID]) {
          model.trigger('remove', model, this, options);
          this.stopListening(model);
          if (model.destroy) {
            model.destroy();
          }
        }
      }
      var k = 0;
      for (var n = 0; n < models.length; n++) {
        var model = models[n];
        if (adds[k] == model) {
          k++;
          model.trigger('add', model, this, _.extend({at: n}, options));
        }
      }

      this.dataType = dataType;
      this.models = models;
      this._modelMap = modelMap;

      _.forEach(this.models, function (model, index) {
        model.position = index;
      });
      } catch (e) { console.error("Error occured.", e.stack); throw e; }
    },

    // Force the collection to re-sort itself. You don't need to call this under
    // normal circumstances, as the set will maintain sort order as each item
    // is added.
    sort: function(options) {
      if (!this.comparator) return;

      if (_.isString(this.comparator) || this.comparator.length === 1) {
        this.models = this.sortBy(this.comparator, this);
      } else {
        this.models.sort(_.bind(this.comparator, this));
      }

      if (!options || !options.silent) this.trigger('sort', this, options);
      return this;
    },

    add: function (model, options) {
      var id = model.id || model.get("id");
      this._modelMap[id] = model;
      var n = this.models.length
      this.listenTo(model, 'all', this._modelEvent);
      this.models.push(model.trigger('add', model, this, _.extend({at: n}, options)));
    },

    get: function (id) {
      return this._modelMap[id];
    },

    at: function(offset) {
      return this.models[offset];
    },

    each: function(cb) {
      if (!cb) return;
      var keys = _.keys(this._modelMap);
      var that = this;
      _.each(keys, function(id) {
        cb(that._modelMap[id], id);
      });
    }

  });

  var _createInstance = function(/*...*/) {
    var C = this,
        args = arguments;
    function tempConstructor() {
      C.apply(this, args);
    }
    tempConstructor.prototype = C.prototype;
    return new tempConstructor();
  }


 var SearchModel = ComputedModel.extend({
// var ViewModel = ComputedModel.extend({
    type: "view",

    remove: function() {},

    initialize: function(wiring, options) {
      var aggregations = {},
          that = this;

      this.aggregations = aggregations;

      // registry for the input changing collections
      this.facetNames = {};
      this.resultProperties = {};
      this.pagesMaxPageCount = {};
    },

    createResultCollection: function() {
      return _createInstance.apply(ResultCollection, arguments);
    },

    createFacetValueCollection: function() {
      return _createInstance.apply(FacetValueCollection, arguments);
    },

    addResultCollection: function (m, options) {
      options = options || {};
      if (m == null || m.cid == null) {
        return;
      }
      if (!this.resultProperties[m.cid]) {
        this.resultProperties[m.cid] = m;
        m.setView(this);

        options = _.extend({}, options, {add:true});
        this._computeChangesToDefinition("properties", this.resultProperties, options);
      }
    },

    addFacet: function(m, options) {
      options = options || {};
      if (m == null || m.cid == null) {
        return;
      }
      if (!this.facetNames[m.cid]) {
        this.facetNames[m.cid] = m;
        m.setView(this);
        if (options.addToFacets !== false) {
          options = _.extend({}, options, {add:true});
          this._computeChangesToDefinition("facets", this.facetNames, options);
        }
      }
    },

    // is called after registering or unregistering a maxPageCount-contributor,
    // e.g. pages model
    // the max value of all the registered values wins
    updateMaxPageCount: function () {
      var maxPageCount = _.max(_.values(this.pagesMaxPageCount));
      if (maxPageCount <= 0) {
        this.input.set("max_page_count", null, { unset: true });
      } else {
        this.input.set("max_page_count", maxPageCount);
      }
    },

    // get a computed model for resultset.result_pages
    // options:
    //   * maxPageCount: maximum number of pages to fetch (default: 10)
    //
    // the more_avail-property is adapted to the maxPageCount option
    getPagesModel: function (options) {
      var that = this;
      var maxPageCount = options.maxPageCount || 10;
      var outputModel = new ReadOnlyTreeModel();
      var originalOutputSubmodel = this.output.submodel("resultset.result_pages");
      var pagesModel;
      var events = "computed";
      originalOutputSubmodel.on("reset", function () {
        outputModel.load({});
      });

      // copy resultset.result_pages to the pages outputModel
      this.on(events, function () {
        var pages = clone(originalOutputSubmodel.get());
        if (pages && pages.pages) {
          // adapt the model to the maxPageCount option of this model,
          // since maxPageCount of other models can be bigger
          pages.pages = pages.pages.slice(0, maxPageCount);
          pages.more_avail = pages.more_avail || pages.pages.length > maxPageCount;
          pages.onFirstPage = pages.pages[0].current_page === true;
          pages.onLastPage = pages.pages[pages.pages.length-1].current_page === true;
        }
        outputModel.load(pages);
      });

      pagesModel = new ComputedModel(
        this.wiring,
        {
          input: this.input.submodel("result_pages"),
          output: outputModel
        }
      );

      pagesModel.loadPage = function (options) {
        that.loadPage(options);
      };

      pagesModel.dispose = function () {
        // update the registry of maxPageCounts on dispose
        delete that.pagesMaxPageCount[pagesModel.cid];
        that.updateMaxPageCount();
        originalOutputSubmodel.dispose();
        ComputedModel.prototype.dispose.apply(this, arguments);
      };

      // update the registry of maxPageCounts on creation
      this.pagesMaxPageCount[pagesModel.cid] = maxPageCount;
      this.updateMaxPageCount();

      return pagesModel;
    },

    clone: function () {
      var newInputModel = this.input.clone();

      return new SearchServiceFactory().createModel(this.wiring.channel, {
          silent: true,
          input: newInputModel,
          output: new SearchOutputModel()
      });// .getViewById(this.get("id"));
    },

    // destroy would be interesting to trigger
    removeResultCollection: function (m, options) {
      if (m == null || m.cid == null) {
        return;
      }

      delete this.resultProperties[m.cid];
      this._computeChangesToDefinition("properties", this.resultProperties, options);
    },

    // destroy would be interesting to trigger
    removeFacet: function (m, options) {
      if (m == null || m.cid == null) {
        return;
      }

      delete this.facetNames[m.cid];
      m.clear();
      m.stopListening();
      this._computeChangesToDefinition("facets", this.facetNames, options);
    },

    updateResultCollection: function(m, options) {
      this._computeChangesToDefinition("properties", this.resultProperties, options);
    },


    /// modelAttribute: e.g. "facets", "properties"
    _computeChangesToDefinition: function(modelAttribute, collectionMap, options) {
      try {
      var options = options || {};
      var currentProperties = this.input.get(modelAttribute) || [];

      // extract the attribute (e.g. 'facet' or 'properties') from the propertiesMap
      // merge the existing
      // this is a list of all the simple properties
      var changedPropertyDefinitions = _.pluck(_.values(collectionMap), modelAttribute);
      // trace("definition: ", JSON.stringify(changedPropertyDefinitions));
      // single property definition: name, format
      // property defintions: name, formats: []
      var idProperty = "name";
      var aggregatedValueProperty = "formats";
      var valueProperty = "format";
      var changedProperties = {};
      var inputChanged = false;
      for (var i = 0; i < changedPropertyDefinitions.length; ++i) {
        var definition = changedPropertyDefinitions[i];
        var keys = _.keys(definition);
        // console.log("*** keys ", keys);
        for (var j = 0; j < keys.length; ++j) {
          var id = keys[j];
          var newValues = [];
          if (definition[id][aggregatedValueProperty]) {
            newValues = definition[id][aggregatedValueProperty];
          }
          else if (definition[id][valueProperty]){
            // console.log(definition[id][valueProperty]);
            newValues.push(definition[id][valueProperty]);
          }

          var target= changedProperties[id];
          if (target) {
            changedProperties[id][aggregatedValueProperty] = _.union(target[aggregatedValueProperty], newValues);
          }
          else {
            changedProperties[id] = {formats: newValues};
          }

          if (definition[id] && definition[id].properties) {
            changedProperties[id].properties = _.extend(changedProperties[id].properties || {}, definition[id].properties);
          }

          if (currentProperties[id] == null) inputChanged = true;
        }
        // trace("properties ",JSON.stringify(changedProperties));
      }


      if (!inputChanged) {
        var k1 = _.keys(currentProperties);
        var k2 = _.keys(changedProperties);
        if (k1.length == k2.length) {
          inputChanged = _.difference(k1,k2).length != 0;
        }
        else {
          inputChanged = true;
        }
      }
      if (!inputChanged) {
        var keys = _.keys(changedProperties);
        for (var i = 0; i < keys.length; i++) {
          var id = keys[i];
          // trace("   curr.formats ", JSON.stringify(currentProperties[id][aggregatedValueProperty]));
          // trace("changed.formats ", JSON.stringify(changedProperties[id][aggregatedValueProperty]));
          var curValues = currentProperties[id][aggregatedValueProperty];
          var chgValues = changedProperties[id][aggregatedValueProperty];
          if (curValues.length != chgValues.length || _.difference(curValues,chgValues).length != 0) {
            // trace("difference break;");
            inputChanged = true;
            break;
          }
        }
      }

      if (inputChanged) {
        if (options.add || this.input.exists()) {
          this.input.set(modelAttribute, changedProperties, options);
        }
      } else if (!options.silent) {
        this.input.change();
      }
      } catch (e) {
        if (console && console.log) console.log(e);
      }
    },

    updateWithPage: function (searchModel, currentPage) {
      if (this._updateWithPageSearchModelCid !== searchModel.cid) {
        return
      }
      // When do we need to abort?
      // When the model is not the same anymore (
      var modelId = _.uniqueId("m");
      var atts = searchModel.get();
      if (this.output && this.output.attributes && this.output.attributes.resultset) {
        if (!atts || !atts.resultset || !atts.resultset.next_avail) {
          this.output.attributes.resultset.next_avail = false;
        }
      }
      _.each(atts && atts.resultset && atts.resultset.results, function (result) {
          result.modelId = modelId;
      });
      // shallow clone to avoid making dates to strings
      var resultset = _.clone(atts.resultset);
      if (!resultset) return;

      if (this.output.attributes.resultset) {
        resultset.order_direction = this.output.attributes.resultset.order_direction;
        delete this.output.attributes.resultset.results;
        delete this.output.attributes.resultset.order_next_result;
        _.each(this.output.attributes.resultset.result_pages.pages, function (page) {
            page.current_page = currentPage.page_number === page.page_number;
        });
        // Since multiple pages have the same page_number on their corresponding service
        // only the first one is selected. The first page of the combined ones has
        // current_page set. Moving current_page to the one with the same offset as our
        // currentPage
        if (currentPage.offset) {
          var markNextPageWithSameOffsetAsCurrentPage
          _.each(this.output.attributes.resultset.result_pages.pages, function (page) {
              if (page.current_page) {
                delete page.current_page;
                markNextPageWithSameOffsetAsCurrentPage = true;
              }
              if (markNextPageWithSameOffsetAsCurrentPage && page.offset === currentPage.offset) {
                page.current_page = true;
                markNextPageWithSameOffsetAsCurrentPage = false;
              }
          });
        }
      }

      // use only the slice of results starting at offset
      resultset.results = resultset.results.slice(currentPage.offset || 0, (currentPage.offset || 0) + resultset.result_pages.page_size);


      // disable display results more relevant than order_next_result
      resultset.order_next_result = undefined;
      // reuse original result_pages since emitSuccessResponse would return merged order
      // instead of original one and thus cause merge problems
      delete resultset.result_pages;

      this.output.submodel("resultset").load(resultset, { parse: false, merge: true });
    },

    loadPage: function (options) {
      var that = this;
      var searchModel;
      var page = options.page;
      var pages = clone(this.output.get("resultset.result_pages"));
      var currentPage = pages.pages[page];
      var i;

      _.each(pages.pages, function (page, index) { delete page.current_page; });
      currentPage.current_page = true;
      this._currentPage = currentPage;

      if (that.input && that.input.validate && !that.input.validate()) {
        return;
      }


      if (!options.disablePropagateComputing) {
        this.trigger("computing");
      }

      searchModel = this.clone();
      this._updateWithPageSearchModelCid = searchModel.cid;

      this.onComputedOrTimeout(searchModel, function (searchModel) { that.updateWithPage(searchModel, that._currentPage); }, Search.DISPLAY_TIMEOUT);

      searchModel.on("computed", function () {
          if (!options.disablePropagateComputing) {
            that.trigger("computed");
          }
          searchModel.off();
          if (options.computedCallback) {
            options.computedCallback();
          }
      });

      searchModel.set("facets", [], { silent: true });
      searchModel.set("result_pages", pages);

      return searchModel;
    },

    // calls the callback when
    //
    // 1. computed is triggered on computedModel
    // 2. change is triggered on computedModel after timeoutInMilliseconds but computed was not triggered
    // 3. if timeoutInMilliseconds is over and change was triggered but computed was not
    onComputedOrTimeout: function (computedModel, callback, timeoutInMilliseconds) {
      var done = false;
      var changed = false;
      var startTime = new Date();
      var timeout = setTimeout(function () {
        if (!done && changed) {
          callback(computedModel);
        }
      }, timeoutInMilliseconds);

      computedModel.on("computed", function () {
        done = true;
        clearTimeout(timeout);
        callback(computedModel);
      });

      computedModel.on("change", function () {
        changed = true;
        if (!done) {
          if (new Date() - startTime > timeoutInMilliseconds) {
            callback(computedModel);
          }
        }
      });
    },

    previousPage: function (options) {
      this._page("PREVIOUS", options);
    },

    nextPage: function (options) {
      options = options || {};

      if (options.append === true) {
        var that = this,
            newModel = this.clone();

        if (that.input && that.input.validate && !that.input.validate()) {
          return;
        }

        if (!options.disablePropagateComputing) {
          this.trigger("computing");
        }
        this.once("computing", function () {
            newModel.off();
        });
        var modelId = _.uniqueId("m");

        var resultCallback = function () {
            var atts = newModel.get();
            if (that.output && that.output.attributes && that.output.attributes.resultset) {
              if (!atts || !atts.resultset || !atts.resultset.next_avail) {
                that.output.attributes.resultset.next_avail = false;
              }
            }
            _.each(atts && atts.resultset && atts.resultset.results, function (result) {
              result.modelId = modelId;
            });
            if (that.input && that.input.validate && !that.input.validate()) {
              return;
            }
            var resultset = atts.resultset;

            // overwrite order_next_result with newModel value, since merging would always prefer the current value
            if (that.output.attributes.resultset) {
              that.output.attributes.resultset.order_next_result = resultset.order_next_result;
            }

            // reuse original result_pages since we would otherwhise merge the same entries in again
            if (resultset) {
              delete resultset.result_pages;
            }
            that.output.submodel("resultset").load(resultset, { parse: false, merge: true, resultComparator: function (lhsResult, rhsResult, options) {
                if (that.options.enableImmediateDisplayOfFederatedResults) {
                  if (lhsResult.modelId !== rhsResult.modelId) {
                    if (lhsResult.modelId === modelId) return 1;
                    if (rhsResult.modelId === modelId) return -1;
                  }
                } else {
                  if (lhsResult._displayed !== rhsResult._displayed) {
                    if (lhsResult._displayed) return -1;
                    else return 1;
                  }
                }
                if (options && options.defaultResultComparator) {
                  return options.defaultResultComparator.apply(that, arguments);
                }
                else {
                  return DEFAULT_RESULT_COMPARATOR.apply(that, arguments);
                }
          }});
          if (resultset) {
            delete resultset.results
          }
        }

        if (this.options.enableImmediateDisplayOfFederatedResults) {
          newModel.on("change", resultCallback);
        } else {
          this.onComputedOrTimeout(newModel, resultCallback, Search.DISPLAY_TIMEOUT);
        }

        newModel.on("computed", function () {
          if (!options.disablePropagateComputing) {
            that.trigger("computed");
          }
          newModel.off();
          newModel.destroy();
          if (options.computedCallback) {
            options.computedCallback();
          }
        });

        newModel.set("facets", [], { silent: true });
        newModel.set("paging_states", that.get("resultset.per_service_dataset.paging_state"), {silent: true})
        newModel.set("paging", {direction: "NEXT"});

        return newModel;
      } else {
        this._page("NEXT", options);
      }
    },

    _page: function (direction) {
      this.set("paging_states", this.get("resultset.per_service_dataset.paging_state"), {silent: true})
      this.set("paging", {direction: direction});
    },

    setSelectedFacetValues: function (facetName, values, filtered_name) {
      var subModel = this.submodel("user.constraints"),
          filterBase = {};

      _.each(values, function (value) {
          filterBase[value] = {
            label: facetName,
            regex: "^\\Q" + value + "\\E$",
            description: value,
            id: value,
            value: {
              str: value
            }
          };
      });

      subModel.set("filter_" + facetName, {
          label: facetName,
          filter_base: filterBase,
          filtered_name: filtered_name
      });

      subModel.destroy();
    },



    // this.wiring
    // this.input
    // this.output


    // _createViewModel: function(id, views) {
    //   var path = ["views", id];
    //   var viewInput = this.input.submodel(path);
    //   var viewOutput = this.output.submodel(path);
    //   var model = new ViewModel(this.wiring, {/*freezeInputPath: true,*/ input: viewInput, output: viewOutput, mainModel: this});

    //   viewInput.set("id", id, { silent: true });
    //   if (views) {
    //     views[id] = model;
    //   }
    //   //console.log(this.input.toJSON());
    //   return model;
    // },

    getViewById: function(viewID) {
      return this;
      // var view = this.views[viewID];
      // if (!view) {
      //   view = this._createViewModel(viewID, this.views);
      // }
      // return view;
    }

  });

  var SearchServiceFactory = Search.ServiceFactory = function() {}

  _.extend(SearchServiceFactory.prototype, ServiceFactory.prototype, {

    createInput:  function(attrs,options) { return new SearchInputModel(attrs, options); },
    createOutput: function(attrs,options) {
      var model = new SearchOutputModel(attrs, options);
      this.proxyEvent({"load": "loadoutput"}, model);
      return model;
    },
    createModel:  function(channel, options) {
      options = options || {};
      options.serviceStub = options.serviceStub || new SearchServiceStub();
      options.defaultResponseOptions = {
      };
      var model = new SearchModel(this.createWiring(channel,options), options);
      this.proxyEvent("compute", model);
      return  model;
    }
  });

  Search.SearchRequest = SearchRequest;
  Search.SearchResponse = SearchResponse;

  Search.and = function () {
    var parts = Array.prototype.slice.apply(arguments);
    if (parts.length < 1) {
      return null;
    } else if (parts.length === 1) {
      return parts;
    }

    var and = [];
    _.each(parts, function (part) {
        if (part) {
          if (part.and && _.keys(part).length === 1) {
            and = and.concat(part.and);
          } else {
            and.push(part);
          }
        }
    });
    return {
      and: and
    };
  }

  return Search;

});
